import React, { useEffect, useRef, useState } from 'react'
import { get_country_calling_codes } from '../../App/validation/countries';
import { get_country_code_and_phone_number } from '../../App/validation/phone_number';
import getCssVariable from '../../App/validation/getCssVariable';
import Modal from '../common_modal/Modal';
import useLanguage from '../common_hooks/useLanguage';
import { MenuItem, Select } from '@mui/material';
import { ArrowBack, CheckCircle } from '@material-ui/icons';
import { send_otp_wa, validate_otp_wa } from '../../App/actions/authActions';
import { useDispatch, useSelector } from 'react-redux';

const phoneNumberList = get_country_calling_codes();

function EditWaNumber({ placeholder }) {
  const user = useSelector(state => state.auth.user)
  const value = user.phone_number;

  const initialized = useRef(false);

  const dispatch = useDispatch();

  const [oldCountryCode, setOldCountryCode] = useState("62");
  const [oldPhoneNumber, setOldPhoneNumber] = useState("");

  const [countryCode, setCountryCode] = useState("62");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isVerified, setIsVerified] = useState(false);
  const [page, setPage] = useState("editor"); // editor atau otp
  const [code, setCode] = useState(["", "", "", "", "", ""])
  const [isModalOpen, setIsModalOpen] = useState(false);

  const complete_number = `${countryCode}${phoneNumber}`
  const is_old_number_verified = user.is_whatsapp_confirm === "success"
  const is_same_number = value === complete_number;

  const { dict, language } = useLanguage()

  useEffect(() => {
    if (initialized.current) return;
    const {
      countryCode,
      phoneNumber = "",
    } = get_country_code_and_phone_number(value);

    setCountryCode(countryCode);
    setPhoneNumber(phoneNumber);
    setIsVerified(is_old_number_verified)
    initialized.current = true;
  }, [is_old_number_verified, value]) // hanya jalankan sekali saat komponen dimount

  useEffect(() => {
    let {
      countryCode,
      phoneNumber = "",
    } = get_country_code_and_phone_number(value);

    setOldCountryCode(countryCode)
    setOldPhoneNumber(phoneNumber)
  }, [value])


  const toggle_modal = () => {
    setIsModalOpen(!isModalOpen)
    setPage("editor");
  }

  const onChangeCountryCode = (code) => {
    setCountryCode(code);
    setIsVerified(false);
  };

  const phoneNumberOnChange = (e, countryCode) => {
    const newPhoneNumber =
      String(e.target.value)?.startsWith("0") || String(e.target.value)?.startsWith(String(countryCode))
        ? e.target.value.slice(String(countryCode)?.length, String(e.target.value)?.length) : e.target.value;

    setPhoneNumber(newPhoneNumber);
    setIsVerified(false);
  };

  const send_otp = () => {
    dispatch(send_otp_wa({ phone_number: complete_number }));
    setPage("otp")
  }

  const handleChange = (value, index) => {
    if (isNaN(value)) return; // hanya menerima angka
    const newOtp = [...code];
    newOtp[index] = value;
    setCode(newOtp)

    // otomatis pindah ke input berikutnya jika terisi
    if (value && index < 5) {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }
  };

  const handleKeyDown = (event, index) => {
    if (event.key === "Backspace" && code[index] === "" && index > 0) {
      document.getElementById(`otp-input-${index - 1}`).focus();
    }
  };

  const handleSubmitCode = async () => {
    const language = localStorage?.language ? localStorage?.language : "ina";
    const otp_code = code?.join("");
    const body = { otp: otp_code, language, phone_number: complete_number };
    const res = await dispatch(validate_otp_wa(body));
    if (res.status === 200) toggle_modal();

  };

  const bg = getCssVariable("--base")

  const change_whatsapp_number_content = (
    <>
      <header>
        <label className="bold font_30">
          {dict["Change Whatsapp Number"][language]}
        </label>
        <div className="flex">
          <hr
            style={{
              height: "2px",
              width: "50%",
              backgroundColor: "black",
              border: "1px solid black",
            }}
          />
          <hr
            style={{
              height: "2px",
              width: "50%",
              backgroundColor: "black",
              border: "1px solid black",
            }}
          />
        </div>
      </header>

      <section className="flex flex_col gap_10 margin_10">
        <p>{dict["Enter your whatsapp correctly"][language]}</p>
        <div className="flex align_center gap_10">
          <Select
            id={"country_calling_code"}
            sx={{ width: "80px" }}
            value={countryCode}
            label="Currency"
            onChange={(e) => onChangeCountryCode(e.target.value)}
            renderValue={() => {
              return `+${countryCode}`;
            }}
          >
            {phoneNumberList.map(({ country_name, calling_code }, index) => (
              <MenuItem key={index} value={calling_code}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <span>{calling_code}</span>
                  <span style={{ color: "#888" }}>{country_name}</span>
                </div>
              </MenuItem>
            ))}
          </Select>

          <input
            placeholder={"Whatsapp"}
            type="number"
            name="rest_number"
            id="whatsapp"
            value={phoneNumber}
            onChange={(e) => phoneNumberOnChange(e, countryCode)}
            className="input_new"
            style={{ borderBottom: "2px solid black" }}
          />
          {(isVerified || is_same_number) && !!countryCode && !!phoneNumber && <CheckCircle fontSize='small' />}
        </div>
        <button
          id="resend"
          className={`border h_40 rounded_5 ${!(isVerified || is_same_number) ? "bg_black" : "bg_grey cursor_default"} text_white marginTop_20`}
          onClick={() => { if (!(isVerified || is_same_number)) send_otp() }}
        >
          {dict["Send OTP"][language]}
        </button>
      </section>
    </>
  );

  const verify_otp_content = <>
    <div className='flex marginBottom_10' style={{ alignItems: "center" }}>
      <button
        onClick={() => setPage("editor")}
        className='rounded_full center_perfect padding_5 bg_black text_white marginRight_10'
      >
        <ArrowBack />
      </button>
      <h2>OTP Verification</h2>
    </div>
    <p>{dict["We have sent the security code to"][language]}</p>

    <h1>{complete_number}</h1>

    <div className="otp-inputs">
      {code.map((value, index) => (
        <input
          key={index}
          id={`otp-input-${index}`}
          type="text"
          maxLength="1"
          value={value}
          onChange={(e) => handleChange(e.target.value, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          className="otp-input"
        />
      ))}
    </div>

    <div className="w_full h_50 center_perfect margin_y_30">
      <button
        id="resend"
        className="border h_40 rounded_5 bg_black text_white marginTop_20 w_full"
        onClick={() => handleSubmitCode()}
      >
        {dict["Verify OTP & save WA number"][language]}
      </button>
    </div>
    <div>
      <p className="text_grey">
        {dict["Didn't receive the code?"][language]}{" "}
        <span
          className="bold pointer"
          style={{ color: "black" }}
          onClick={() => send_otp()}
        >
          {dict["Resend"][language]}
        </span>{" "}
      </p>
    </div>
  </>

  let modal_change_number_content = null;
  if (page === "editor") {
    modal_change_number_content = change_whatsapp_number_content;
  } else if (page === "otp") {
    modal_change_number_content = verify_otp_content;
  }

  const modalChangeNumber = isModalOpen && <Modal
    modalSize="small"
    id="modal"
    isOpen={isModalOpen}
    onClose={() => toggle_modal()}
  >
    {modal_change_number_content}
  </Modal>


  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "10px"
      }}>
      <label style={{
        fontWeight: 600
      }}>{placeholder}</label>
      <div
        style={{
          height: '50px',
          backgroundColor: bg,
          width: "100%",
          borderRadius: "5px",
          display: "flex",
          alignItems: "center",
          cursor: "pointer"
        }}
        onClick={() => toggle_modal()}
      >
        <div
          style={{
            padding: '5px 0 5px 0',
            marginLeft: "15px",
            display: "flex",
            gap: "5px"
          }}
        >
          <div>+{oldCountryCode}</div>
          <div>{oldPhoneNumber}</div>
          {is_old_number_verified && <CheckCircle fontSize='small' />}
        </div>
      </div>

      {modalChangeNumber}
    </div>

  )
}

export default EditWaNumber